import createIcon from '../../createIcon';

/**
 * @component @name Dangerous
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzMgM0g4LjI3TDMgOC4yN1YxNS43M0w4LjI3IDIxSDE1LjczTDIxIDE1LjczVjguMjdMMTUuNzMgM1pNMTcgMTUuNzRMMTUuNzQgMTdMMTIgMTMuMjZMOC4yNiAxN0w3IDE1Ljc0TDEwLjc0IDEyTDcgOC4yNkw4LjI2IDdMMTIgMTAuNzRMMTUuNzQgN0wxNyA4LjI2TDEzLjI2IDEyTDE3IDE1Ljc0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dangerous = createIcon('Dangerous', [
  [
    'path',
    {
      d: 'M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM17 15.74L15.74 17L12 13.26L8.26 17L7 15.74L10.74 12L7 8.26L8.26 7L12 10.74L15.74 7L17 8.26L13.26 12L17 15.74Z',
      key: 'z3awja',
    },
  ],
]);

export default Dangerous;
